import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appInsights } from "./appInsights";

export function usePageTracking() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    appInsights.trackPageView({
      name: pathname,
      uri: window.location.href,
      properties: { pathname, search, hash },
    });
  }, [pathname, search, hash]);
}
